import React from 'react';
import Actions from '../actions/Actions';
import ContentPDF from '../../../../components/content-pdf/ContentPDF';

type Props = {
  data: string;
  isFullScreen: boolean;
};

function Pdf(props: Props) {
  const { data, isFullScreen } = props;
  return (
    <Actions fullScreen={isFullScreen}>
      <ContentPDF data={data}/>
    </Actions>
  );
}

export default Pdf;
